module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_border-4b8030189a93d1bf5a88e87559ce2090.gif";